export const CAN_SEE_SURGE_CHOICES = [
  { id: 'yes', name: 'Yes' },
  { id: 'no', name: 'No' },
];
